export default __webpack_public_path__ + "static/media/whiteLogo.62bfbac2.svg";